type ErrorWithMessage = {
  message?: string;
  extensions?: {
    category?: string;
  };
};

const CREDENTIAL_ERROR_PATTERNS = [
  /consumer key has expired/i,
  /consumer\s+.*\s+expired/i,
  /invalid consumer/i,
  /consumer is not authorized/i,
  /integration\s+token\s+expired/i,
];

const hasCredentialPatternMatch = (value?: string) => {
  if (!value) {
    return false;
  }

  return CREDENTIAL_ERROR_PATTERNS.some((pattern) => pattern.test(value));
};

export const isBackendCredentialError = (errorOrErrors: unknown): boolean => {
  if (!errorOrErrors) {
    return false;
  }

  if (Array.isArray(errorOrErrors)) {
    return errorOrErrors.some((error) => isBackendCredentialError(error));
  }

  if (errorOrErrors instanceof Error) {
    return hasCredentialPatternMatch(errorOrErrors.message);
  }

  if (typeof errorOrErrors === 'object') {
    const typedError = errorOrErrors as ErrorWithMessage;

    if (hasCredentialPatternMatch(typedError.message)) {
      return true;
    }

    return hasCredentialPatternMatch(typedError.extensions?.category);
  }

  if (typeof errorOrErrors === 'string') {
    return hasCredentialPatternMatch(errorOrErrors);
  }

  return false;
};

export const getBackendCredentialErrorMessage = (errorOrErrors: unknown): string => {
  if (Array.isArray(errorOrErrors)) {
    const firstMessage = errorOrErrors
      .map((item) => getBackendCredentialErrorMessage(item))
      .find((message) => message.length > 0);

    return firstMessage || 'Backend credential error';
  }

  if (errorOrErrors instanceof Error) {
    return errorOrErrors.message;
  }

  if (typeof errorOrErrors === 'object' && errorOrErrors !== null) {
    const typedError = errorOrErrors as ErrorWithMessage;

    return typedError.message || typedError.extensions?.category || 'Backend credential error';
  }

  if (typeof errorOrErrors === 'string') {
    return errorOrErrors;
  }

  return 'Backend credential error';
};